function required(name: string, value: string | undefined): string {
  if (!value) {
    const message =
      `Missing ${name}. Deploy the infrastructure and run the deploy script, which writes ` +
      `apps/web/.env.production from the stack outputs, or copy .env.example to .env.local ` +
      `and fill it in for local development.`;
    console.error(`[somasi] ${message}`);
    throw new Error(message);
  }
  return value;
}

export const awsConfig = {
  /** The API Gateway base URL. The app is hosted separately, so calls are
   * cross-origin and this origin must be in the API's CORS allowlist. */
  apiUrl: required("VITE_API_URL", import.meta.env.VITE_API_URL).replace(/\/$/, ""),
  userPoolId: required("VITE_USER_POOL_ID", import.meta.env.VITE_USER_POOL_ID),
  userPoolClientId: required("VITE_USER_POOL_CLIENT_ID", import.meta.env.VITE_USER_POOL_CLIENT_ID),
  region: required("VITE_AWS_REGION", import.meta.env.VITE_AWS_REGION),
};
